import organisatieApi from "../../../api/organisatieApi";
import identificatieApi from "../../../api/identificatieApi";
import * as messages from "../../../constants/ToastrConstants";
import { showToastrError, showToastrSuccess, showToastrWarning } from "../../../util/toastr";
import mergeDeep from "../../../util/mergeDeep";
import { ValidationMessageTypes } from "../../../constants/ComponentConstants";
import { convertFileToByteArray } from "../../../components/common/FilesHelperUtil";
import { getSettings } from "../../../store/configureStore";

import assign from 'object-assign';

export default class OrganisatiePageHelper {

	constructor(context, redirector) {
		this.context = context;
		this.redirector = redirector;
	}

	init() {
		const context = this.context;
		const ajaxActions = context.props.ajaxActions;
		const params = context.props.match.params;
		const transactieId = params.transactieId;
		const isNew = context.props.isNew;
		const disabled = context.props.disabled;
		const searchModel = context.props.searchModel;

		ajaxActions.started();

		if (isNew && (!transactieId || transactieId == "null")) {
			organisatieApi.create(searchModel)
				.then((response) => {
					ajaxActions.ended();
					this.processModel(response.data, {}, '', false);
				})
				.catch((ex) => {
					ajaxActions.failed();
					context.props.throwException(ex, true);
				});
		}
		else if (transactieId) {
			organisatieApi.get(transactieId, isNew)
				.then((response) => {
					ajaxActions.ended();
					this.processModel(response.data, {}, '', false);
				})
				.catch((ex) => {
					ajaxActions.failed();
					if (ex.response.status === 404) {
						showToastrError(messages.MESSAGE_NO_VALID_TRANSACTION_FOUND);
						this.redirector.goTo("/federatie/overzicht");
					}
					else {
						context.props.throwException(ex, true);
					}
				});

			if (!disabled && !isNew && !context.props.activateSportorganisatiePopupAlreadyShown) {
				ajaxActions.started();
				identificatieApi.getSportclubIsActive(transactieId)
					.then((response) => {
						ajaxActions.ended();
						if (!response.data) {
							context.props.setActivatiePopupShown();
							context.setState({ activateModalIsOpen: true });
						}
					})
					.catch((ex) => {
						ajaxActions.failed();
					});
			}

			context.setState({
				transactieId
			});
		}

	}

	save() {
		const context = this.context;
		const ajaxActions = context.props.ajaxActions;
		const params = context.props.match.params;
		const transactieId = this.context.props.transactieId;

		let errors = null;
		let model = null;

		let modelToSave = {
			transactionId: transactieId,
			model: this.context.state.model
		};
		modelToSave.type = 2;
		modelToSave.niveau = 6;

		ajaxActions.started();
		return organisatieApi.save(modelToSave).then((response) => {
			ajaxActions.ended();
			let hasUnsavedChanges = this.context.hasUnsavedChanges;
			let validationMessageType;
			if (response.statusText === "OK" && !response.data.hasValidationErrors) {
				if (Object.keys(response.data.validationResults).length !== 0) {
					model = assign({}, response.data.item);
					errors = assign({}, response.data.validationResults);
					showToastrWarning(messages.MESSAGE_VALIDATION_ERRORS);
					showToastrSuccess(messages.MESSAGE_SAVED);
				}
				else {
					model = assign({}, response.data.item, {});
					errors = {};
					showToastrSuccess(messages.MESSAGE_SAVED);
				}
				hasUnsavedChanges = false;
				validationMessageType = ValidationMessageTypes.WARNING;
				this.processModel(model, errors, validationMessageType, hasUnsavedChanges);
			} else {
				errors = assign({}, response.data.validationResults);
				model = assign({}, response.data.item, {});
				showToastrError(messages.MESSAGE_VALIDATION_ERRORS);
				validationMessageType = ValidationMessageTypes.ERROR;
				this.context.setState({
					errors,
					validationMessageType,
					shouldScrollToFirstError: true
				});
			}
		})
			.catch((ex) => {
				ajaxActions.failed();
				if (ex.response.status === 404) {
					showToastrError(messages.MESSAGE_NO_VALID_TRANSACTION_FOUND);
					context.setState({ hasUnsavedChanges: false });
					context.props.setHasUnsavedChanges(false);
					this.redirector.goTo("/federatie/overzicht");
				}
				else {
					context.props.throwException(ex, true);
				}
			});
	}

	processModel(response, validationResults, validationMessageType, hasUnsavedChanges) {
		const context = this.context;
		let errors = validationResults;

		const tabSettings = response.tabSettings;

		if (context.props.isNew) {
			context.props.setActiveSportclub(response.model.id, response.transactionId, context.props.disabled, true);
			context.props.loadLayout(`Nieuwe sportclub`, false);
		}
		else {
			context.props.setActiveSportclub(response.model.id, response.transactionId, context.props.disabled, false);
			context.props.loadLayout(`${response.model.naam}`, false);
		}

		context.props.setTabSettings(tabSettings);
		context.props.setActiveOrganisatieNiveau(6);

		context.setState({
			originalModel: mergeDeep({}, response.model),
			model: response.model,
			errors,
			validationMessageType,
			shouldScrollToFirstError: true,
			hasUnsavedChanges: hasUnsavedChanges
		});
		context.props.setHasUnsavedChanges(hasUnsavedChanges);
	}

	change(event) {
		const value = event.target.value;
		const property = event.target.name;

		const model = this.context.state.model;
		model[property] = value;

		this.context.setState({
			model,
			hasUnsavedChanges: true,
			nameHasFocus: false
		});
		this.context.state.hasUnsavedChanges === true || this.context.props.setHasUnsavedChanges(true);
	}

	changeFile(event) {
		const value = event.target.value;
		const property = event.target.name;
		const context = this.context;

		const model = context.state.model;
		const maxAllowedContentLength = Number(getSettings().maxAllowedContentLength) / 2;

		if (value && value.length) {
			if (value[0].size > maxAllowedContentLength) {
				showToastrError("Het '" + value[0].name + "' bestand is te groot. Maximum 100MB per bestand.");
				return;
			}
			convertFileToByteArray(context, value[0], property);
		}
		else {
			model[property] = null;
			context.setState({
				model,
				hasUnsavedChanges: true
			});
			this.context.state.hasUnsavedChanges === true || context.props.setHasUnsavedChanges(true);
		}
	}

	activateSportclub() {
		const context = this.context;
		const ajaxActions = context.props.ajaxActions;
		const params = context.props.match.params;
		const transactieId = this.context.props.transactieId;

		ajaxActions.started();

		identificatieApi.activateSportclub(transactieId)
			.then(() => {
				ajaxActions.ended();
				this.closeActivateModal();
				this.init();
			})
			.catch((ex) => {
				ajaxActions.failed();
			});
	}

	closeActivateModal() {
		const context = this.context;
		context.setState({
			activateModalIsOpen: false,
			sportclubToActivateId: null
		});
	}
}
